import { gql } from '@apollo/client';
import changeDateRequestEventFragment from '@shared/fragments/changeDateRequestEventFragment';

const FDA_REVIEW_CHANGE_DATE_REQUEST = gql`
  mutation FdaReviewChangeDateRequest($requestData: AppraiserEventChangeDateReviewedInput!) {
    reviewChangeDateRequest(requestData: $requestData) {
      ...ChangeDateRequestEventFields
    }
  }

  ${changeDateRequestEventFragment}
`;

export default FDA_REVIEW_CHANGE_DATE_REQUEST;
